export default __webpack_public_path__ + "locales/sl/Notifications.json?hash=304b04004e99e1055683ad06f86a7ed5";